<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">TEST PILOTS</p>
<p class="half1">OF THE</p>
<p class="half2">JET AGE</p>
<a id="page_ii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?d3913ff8